export abstract class AppError extends Error {
  constructor(message: string) {
    super(message);
    this.name = new.target.name;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class NetworkError extends AppError {
  constructor(message = 'Network connection lost.') {
    super(message);
  }
}

export class BackendError extends AppError {
  constructor(
    public statusCode: number,
    message: string,
  ) {
    super(message);
  }
}

export class ValidationError extends AppError {
  constructor(
    public field: string,
    message: string,
  ) {
    super(message);
  }
}

export class ConcurrencyError extends AppError {
  constructor(message = 'Resource version conflict detected.') {
    super(message);
  }
}

export class UnknownError extends AppError {
  constructor(message = 'Unexpected application error.') {
    super(message);
  }
}
